import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";

const Gallery = {
  init() {
    this.load();
  },

  load() {
    $.ajax({
      url: ajaxurl,
      data: {
        action: "photoswipe",
      },
      type: "POST",
      dataType: "JSON",
      success: function (response) {
        $(".main").append(response);
        Gallery.build();
      },
    });
  },

  build() {
    $(".gallery").each(function () {
      var th = $(this);
      var data = [];
      var items = $(".gallery__item", th).length;

      $(".gallery__item", th).each(function () {
        let img = $("img", this);
        data.push({
          src: img.attr("src"),
          w: img.attr("width"),
          h: img.attr("height"),
        });
      });

      $(".gallery__slider", th).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        adaptiveHeight: true,
        asNavFor: $(".gallery__thumbs", th),
        infinite: items > 7,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              infinite: items > 5,
            },
          },
          {
            breakpoint: 500,
            settings: {
              infinite: items > 3,
            },
          },
        ],
      });

      $(".gallery__thumbs", th).slick({
        slidesToShow: 7,
        slidesToScroll: 1,
        asNavFor: $(".gallery__slider", th),
        dots: false,
        arrows: false,
        focusOnSelect: true,
        centerMode: true,
        infinite: items > 7,
        centerPadding: 0,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 5,
              infinite: items > 5,
            },
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 3,
              infinite: items > 3,
            },
          },
        ],
      });

      $(".gallery__item", th).click(function (e) {
        var current = parseInt($(this).data("item"));

        var options = {
          index: current,
          maxSpreadZoom: 1,
          getDoubleTapZoom: function (isMouseClick, item) {
            return item.initialZoomLevel;
          },
          closeOnScroll: false,
          history: false,

          // Size of top & bottom bars in pixels,
          barsSize: {
            top: 44,
            bottom: 0,
          },

          // Buttons/elements
          zoomEl: false,
          shareEl: false,
          counterEl: false,

          // Tap on sliding area should close gallery
          tapToClose: true,

          // Tap should toggle visibility of controls
          tapToToggleControls: false,

          // Mouse click on image should close the gallery,
          clickToCloseNonZoomable: false,

          // Element classes click on which should close the PhotoSwipe.
          closeElClasses: ["item", "caption", "zoom-wrap", "ui"],
        };

        var pswpElement = document.querySelectorAll(".pswp")[0];

        var gallery = new PhotoSwipe(
          pswpElement,
          PhotoSwipeUI_Default,
          data,
          options
        );
        gallery.init();
      });
    });
  },
};

export default Gallery;
